import { useState } from "react";
import { IoAddOutline } from "react-icons/io5";

import TextboxSearch from "../../../components/common/TextboxSearch";
import TableControls from "../../../components/common/TableControls";
import Modal from "../../../components/common/Modal";
import PTRForm from "./PTRForm";

const PTRHeader = ({ account, settings, onFilter, onSearch, onSuccess }) => {
  const [showForm, setShowForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="block lg:flex justify-between items-center">
      <div>
        <p className="text-gray-500 text-sm">Professional Tax Receipts</p>
        <span className="text-gray-400 text-xs">
          List of Professional Tax Receipts
        </span>
      </div>
      <div className="mt-5 lg:mt-0 block md:flex md:space-x-2">
        <TextboxSearch placeholder="Search..." onSearch={onSearch} />
        <TableControls onFilter={() => onFilter(true)} settings={settings} />
        <button
          className="button button-primary mt-2 md:mt-0"
          onClick={() => setShowForm(true)}
        >
          <IoAddOutline className="mr-2" />
          Create PTR
        </button>
        <Modal
          title="Create PTR"
          isOpen={showForm}
          isLoading={isLoading}
          onClose={() => setShowForm(false)}
          borderTop
        >
          <PTRForm
            account={account}
            isLoading={isLoading}
            setLoading={setIsLoading}
            setShowForm={setShowForm}
            onSuccess={onSuccess}
          />
        </Modal>
      </div>
    </div>
  );
};

export default PTRHeader;
